module.exports = __webpack_public_path__ + "img/existing-mobile.60e1a680.png";